const COLOR_MODE_PREFERENCE_KEY = 'ADS-COLOR-MODE';

export const useSSRSafeThemeObserver = () => {
	try {
		const storedTheme = localStorage.getItem(COLOR_MODE_PREFERENCE_KEY);
		if (storedTheme && ['light', 'dark'].includes(storedTheme)) {
			return storedTheme;
		}
	} catch (e) {}
	// Return fallback if no preference is found or local storage is unavailable
	return 'fallback';
};
